import React, { useState, useEffect, Fragment } from "react";

const UsecalendarYearTable = (
    emptypeData,
    handleDelReview,
    handleEditReview,
    onClickToggleFromTable
) => {
  const [thead] = useState(["CalendarYear", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = emptypeData.map((el) => {
      return {
        "CalendarYear": el.description,
        Action: (
          <Fragment>
             <i
              className="fas fa-edit ml-4"       
              style={{ marginRight: "10px", cursor: "pointer" }}               
              onClick={() => {
                handleEditReview(el, el.calanderyearId);
                onClickToggleFromTable();
             }}
            >&nbsp;</i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelReview(el.calanderyearId)}
            ></i>
           
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }, [
    emptypeData,
    handleDelReview,
    handleEditReview,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default UsecalendarYearTable;